<script setup>
    const props = defineProps({
        height: { type: String, required: false, default: '24px' },
        width: { type: String, required: false, default: '100%' }
    });
</script>
<template>
    <div class="loading-placeholder" :style="props">
        <div class="placeholder-background"></div>
    </div>
</template>
<style lang="scss" scoped>
@import '@Common/Styles/variables';

@keyframes loadingHighlight{
    0% {
        background-position: -50vw 0
    }
    100% {
        background-position: 50vw 0
    }
}

.loading-placeholder {
    height: 24px;
    width: 100%;
    background-color: map-get($yapla-gray, 200);
    border-radius: 4px;
    position: relative;
    overflow: hidden;

    .placeholder-background {
        position: relative;
        animation-duration: 1.25s;
        animation-fill-mode: forwards;
        animation-iteration-count: infinite;
        animation-name: loadingHighlight;
        animation-timing-function: linear;
        background: darkgray;
        background: linear-gradient(to right, map-get($yapla-gray, 200) 10%, map-get($yapla-gray, 100) 18%, map-get($yapla-gray, 200) 33%);
        background-size: 100vw 100vh;
        height: 100%;
    }
}
</style>